/** @jsx jsx */
import { cssMap, jsx } from '@atlaskit/css';
import { Drawer, DrawerContent as DrawerPanelContent } from '@atlaskit/drawer';
import { token } from '@atlaskit/tokens';
import { defaultProps as projectCreateDefaultProps } from '@atlassian/jira-project-create-main/src/common/constants.tsx';
import { useQueryParam } from '@atlassian/react-resource-router';
import type { DrawerContentProps } from '../types.tsx';

const styles = cssMap({
	drawerContent: {
		marginTop: token('space.0'),
	},
});

const DrawerContent = (props: DrawerContentProps) => {
	const {
		onClose,
		isAdmin,
		isOnboarding,
		data,
		appEditions,
		methods,
		onScreenChange,
		onPermissionsFetched,
		ProjectCreate,
	} = props;
	const defaultSelectedTemplateKey =
		data.defaultSelectedTemplateKey !== undefined
			? data.defaultSelectedTemplateKey
			: projectCreateDefaultProps.defaultSelectedTemplateKey;
	const isTemplatePickerOpenInitially =
		data.isTemplatePickerOpenInitially !== undefined
			? data.isTemplatePickerOpenInitially
			: projectCreateDefaultProps.isTemplatePickerOpenInitially;
	const isImportProjectOpenInitially =
		data.isImportProjectOpenInitially !== undefined
			? data.isImportProjectOpenInitially
			: projectCreateDefaultProps.isImportProjectOpenInitially;
	const selectedProjectType =
		data.selectedProjectType !== undefined
			? data.selectedProjectType
			: projectCreateDefaultProps.selectedProjectType;
	let source = data.source !== undefined ? data.source : projectCreateDefaultProps.source;

	// https://softwareteams.atlassian.net/browse/RLSS-4346
	const [originSource] = useQueryParam('originSource');
	if (!source && originSource !== undefined) {
		source = originSource;
	}

	return (
		<Drawer isOpen={data.isOpen} width="full" onClose={onClose} autoFocusFirstElem>
			<DrawerPanelContent xcss={styles.drawerContent}>
				<ProjectCreate
					// @ts-expect-error new project create has less props
					isAdmin={isAdmin}
					isOnboarding={isOnboarding}
					isJswOnboarding={false}
					isJiraCoreOnboarding={false}
					skipTemplateSelection={false}
					isNextGen={data.isNextGen}
					showExperienceSelection={data.showExperienceSelection}
					recommendedTemplate={data.recommendedTemplate}
					isConnectedProjectScenario={false}
					defaultSelectedTemplateKey={defaultSelectedTemplateKey}
					isTemplatePickerOpenInitially={isTemplatePickerOpenInitially}
					isImportProjectOpenInitially={isImportProjectOpenInitially}
					selectedProjectType={selectedProjectType}
					appEditions={appEditions}
					onCancel={methods.close}
					onSuccess={methods.onSuccess}
					onScreenChange={onScreenChange}
					onPermissionsFetched={onPermissionsFetched}
					source={source}
					onDrawerClose={onClose}
					setOnCloseCallback={methods.setOnCloseCallback}
					onCreateStarted={methods.onCreateStarted}
					recommendationSessionId={data.recommendationSessionId}
				/>
			</DrawerPanelContent>
		</Drawer>
	);
};

export default DrawerContent;
